import { Conversation } from "../types";

/** Returns true if the conversation was started by a patient triage request */
export const getIsConversationTriageRequest = (conversation: Conversation) => {
    if (conversation.items.length === 0) return false;

    return conversation.items[0].contentType === "PatientTriageRequestNote";
};
